import React from 'react'
import { haveAnyValue } from 'src/utils/utilitiesV2'
import { Card, Paragraph } from 'src/components/index'

interface AlertSimpleProps {
  title?: string
  description?: string
}

export const AlertSimple = ({ title, description }: AlertSimpleProps) => {
  return (
    <Card title={title} white>
      {haveAnyValue(description) && <Paragraph>{description}</Paragraph>}
    </Card>
  )
}
